import axios from "axios";
import { BaseUrl } from "./basr_url";

const instance = axios.create({ baseURL: BaseUrl });

instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});

export default instance;
// baseURL: "https://dev.screenit.io/api",
// baseURL: "http://localhost:3001"
